import { z } from 'zod';

/**
 * The school's opening and closing time, as the office changes them.
 *
 * Mirrors `updateTimingsSchema` in the server's `staffAttendance.validation.ts`.
 * For fast feedback only — the server checks both rules again.
 */
const clockTime = z
  .string()
  .trim()
  .regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Choose a time');

export const timingsSchema = z
  .object({
    startsAt: clockTime,
    endsAt: clockTime,
  })
  .refine((value) => value.endsAt > value.startsAt, {
    path: ['endsAt'],
    message: 'The day must end after it starts',
  });

export type TimingsFormValues = z.infer<typeof timingsSchema>;
